import { Suspense } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { useSharedUrl, useTheme, ToastProvider } from './hooks';
import { OfflineBanner, ToastContainer } from './components/shared';

function App() {
  // Apply theme class to <html> on mount and react to changes
  useTheme();

  // Handle PWA share target URLs
  const { state: sharedUrlState } = useSharedUrl();

  return (
    <ToastProvider>
      {/* Offline banner */}
      <OfflineBanner />

      {/* Toast notifications */}
      <ToastContainer />

      {/* Display inline progress for shared URL ingestion */}
      {sharedUrlState.isProcessing && (
        <div className="fixed top-4 right-4 z-50 bg-background border border-border rounded-lg shadow-lg p-4 max-w-sm">
          <div className="flex items-center gap-3">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-primary border-t-transparent" />
            <div className="flex-1">
              <p className="text-sm font-medium">Processing shared URL...</p>
              {sharedUrlState.progress && (
                <p className="text-xs text-muted-foreground mt-1">
                  {sharedUrlState.progress}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Display error for shared URL ingestion */}
      {sharedUrlState.error && (
        <div className="fixed top-4 right-4 z-50 bg-destructive/10 border border-destructive rounded-lg shadow-lg p-4 max-w-sm">
          <div className="flex items-center gap-3">
            <svg
              className="h-4 w-4 text-destructive flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            <div className="flex-1">
              <p className="text-sm font-medium text-destructive">
                {sharedUrlState.error}
              </p>
            </div>
          </div>
        </div>
      )}

      <Suspense
        fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-muted-foreground">Loading...</div>
          </div>
        }
      >
        <RouterProvider router={router} />
      </Suspense>
    </ToastProvider>
  );
}

export default App;
